<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-sd-12 col-12 rotated-labels">
          <chart-card :key='akamai_invoice_data'
            :chart-data="akamai_invoice_data.data"
            :chart-options="akamai_invoice_data.options"
            :responsive-options="akamai_invoice_data.responsiveOptions"
            chart-type="Line">
            <template slot="header">
              <h4 class="card-title">Akamai Costs</h4>
              <p class="card-category">(K$)</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <!-- <i class="fa fa-circle text-info"></i> Tesla Model S
                <i class="fa fa-circle text-danger"></i> BMW 5 Series -->
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> Data from Akamai Invoices via Redshift
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-md-6 col-sd-12 col-12">
          <!-- <h5 class="card-title">Costs per Product</h5>               -->
            <div slot="content">
              <enhanced-table class='small' :nosearch=true :datalist="akamai_product"/>
            </div>
          </div>
        </div>

          <div class="col-md-12 rotated-labels">
            <chart-card :key='akamai_products_histogram'
                        :chart-data="akamai_products_histogram.data"
                        :chart-options="akamai_products_histogram.options"
                        :responsive-options="akamai_products_histogram.responsiveOptions"
                        chart-type="Bar"
                        >
              <template slot="header">
                <h4 class="card-title">Costs by Product</h4>
                <p class="card-category">Values in $</p>
                <div>
                  <multiselect v-model="filtered" label="name" track-by="code" :options="options" :multiple="true" :taggable="true" ></multiselect>
                </div>

              </template>
              <template slot="footer">
                <div class="legend">
                  <div v-for="(k,i) in seriesNames " style="cursor: pointer">
                    <i class="fa fa-circle" :style='{color: colors[i]}' ></i>
                    <span>{{k}}</span>
                  </div>
                </div>
                <hr>
                <div class="stats">
                  <i class="fa fa-check"></i> Data from Akamai Invoices via Redshift
                </div>
              </template>
            </chart-card>
          </div>
        </div>

      </div>
         
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'

  import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard,
      Multiselect,
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.filtered = this.options
      axios
        .get('/akamai/invoices?access_token=' + this.accessToken)
        .then(response => (
        	this.akamai_invoices = response.data.totals,
			this.akamai_detailed_invoices = response.data.invoices,
            this.akamai_product = response.data.per_product
        ));
    },
    methods: {
      getColor: function(prd){
        // locate the index of the color on the products currently selected
        
        return colors[ this.seriesNames.indexOf(prd) ]
      },
      handleSeries: function(product){
        var labels = []
        this.seriesNames = []
        var vm=this

        var initial_series= []
        // prepare labels
        this.akamai_detailed_invoices.forEach(function( it ){
          if (labels.indexOf(it['year_month']) == -1){
            labels.push(it['year_month'])
            initial_series.push(0)
          }
        })
        //prepare series based on visibility
        Object.keys(this.akamai_invoice_products).forEach(function(prd){
          if (
            vm.filtered.some(function(it){
              if (it['name'] == prd){
                return true
              }
            }) 
            ){
              vm.seriesNames.push(prd)
            }
        })

        var list_of_series = []
        
        // loop over all the selected products
        this.seriesNames.forEach(function(prd){
          var series = [...initial_series]
          //filter the current product to be charted
          vm.akamai_detailed_invoices.filter(function(el){
            if (prd == el['product'] ){
              return el
            }
          })
          // for a given product, generate the list of points to the serie
          .forEach(function(el){
            series[labels.indexOf(el['year_month']) ] += el['total']
          })
          list_of_series.push(series)
        })
        
        // series.forEach(function(prd_serie){
        //   var line = []
        //   prd_serie.forEach(function(data){
        //     line.push(data['total'])
        //   })
        //   newseries.push(line)
        // })
        // prepare the histogram object that will be ploted
        this.akamai_products_histogram = {
          'data': {
            'labels': labels,
            'series': list_of_series,
            'serieNames': this.seriesNames
          },
          'options': Object.assign({}, chart_base.options),
          'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
        }
        //override of chart_base
        this.akamai_products_histogram.options.stackBars= true
        this.akamai_products_histogram.options.seriesBarWidth=40
        this.akamai_products_histogram.options.tooltip.tooltipOffset= {               
          x: 15,
          y: 140
        }
 
      },
    },
    watch: {
      filtered: function(){
        this.handleSeries()
      },
      force_refresh: function (){
        this.handleSeries(this.akamai_product[0]['product'])
        this.handleSeries(this.akamai_product[1]['product'])
        this.handleSeries(this.akamai_product[2]['product'])

      },
      akamai_product: function(){
        if (this.akamai_product.length >0){
          this.force_refresh = ! this.force_refresh
        }
      },
      akamai_detailed_invoices: function(){
        var products = {}
        var vm = this
        this.akamai_detailed_invoices.forEach(function(v){
          products[v['product']]=false
        })
        this.akamai_invoice_products = products

        if (this.akamai_detailed_invoices.length > 0){
          this.force_refresh = ! this.force_refresh
        }

      },
      akamai_invoices:function(){
        var labels = []
        var series = []
        this.akamai_invoices.forEach(function(v){
          labels.push(v['year_month'])
          series.push(v['total']/1000)
        })

        this.akamai_invoice_data = {
          'data': {
            'labels': labels,
            'series': [series]
          },
          'options': Object.assign({}, chart_base.options),
          'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
        }
        //override of chart_base
        this.akamai_invoice_data.options.tooltip.tooltipOffset= {               
          x: 15,
          y: 80
        }

        this.akamai_invoice_data.options.seriesBarWidth=40
        this.akamai_invoice_data.options.seriesBarDistance = 5

      }
    },
    computed: {
      
    },
    data () {
      return {
        accessToken:'',
        options: [
          {code: "AO", name:"Advanced Offload"},
          {code: "BMP", name:"Bot Manager Premier"},
          {code: "DSD", name:"Dynamic Site Delivery"},
          {code: "IMA", name:"Ion Media Advanced"},
          {code: "KSD", name:"Kona Site Defender"},
          {code: "MKSDS", name:"Managed Kona Site Defender Service"},
          {code: "NS", name:"NetStorage"},
          {code: "PSS", name:"Premium Service and Support 2.0"},
          {code: "SOA", name:"Security Optimization Assistance"},
          {code: "SOASOA", name:"Security Optimization Assistance::Security Optimization Assistance"},
          {code: "SNA", name:"SSL Network Access - 3rd Party Certificate"},
          {code:"SNA3", name:"SSL Network Access - 3rd Party Certificate - VIP"},
        ],
        filtered:[],
        colors: colors,

        akamai_invoices:[],
        force_refresh: true,
        akamai_invoice_data:{},
        akamai_product:[],
        akamai_product_data:[],
        akamai_products_histogram:{},
        seriesNames:[],
        akamai_invoice_products:[],
        akamai_detailed_invoices:[],
        chart_base: chart_base,
      }
    }
  }
</script>
<style>

</style>
